"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appRecorderFactory = exports.recorderFactory = exports.differenceFromRoot = exports.difference = exports.recordMultiple = exports.recordOnce = exports.getTimeOf = exports.resetTimings = void 0;
const env_1 = require("../env");
const getInitTime_1 = __importDefault(require("./getInitTime"));
const getCurrentTime_1 = __importDefault(require("./getCurrentTime"));
const trackTiming_1 = require("./trackTiming");
let timeMappingMap = new Map();
function resetTimings() {
    timeMappingMap = new Map();
}
exports.resetTimings = resetTimings;
function getTimeOf(event) {
    return timeMappingMap.get(event) ?? null;
}
exports.getTimeOf = getTimeOf;
function addTime(event, timeSince0, options) {
    timeMappingMap.set(event, timeSince0);
    (0, trackTiming_1.trackSingleTime)(event, timeSince0, options);
}
function recordOnce(event, options) {
    try {
        if (!timeMappingMap.has(event)) {
            return record(event, options);
        }
        if ((0, env_1.isDebug)()) {
            console.log('RecordOnce: Fired second time for event = ', event);
        }
        return null;
    }
    catch (e) {
        return null;
    }
}
exports.recordOnce = recordOnce;
function record(event, options) {
    try {
        const timeSince0 = Math.round((0, getCurrentTime_1.default)() - (0, getInitTime_1.default)());
        addTime(event, timeSince0, options);
        if ((0, env_1.isDebug)()) {
            console.log('Timing', event, timeSince0);
        }
        return timeSince0;
    }
    catch (e) {
        // prevent errors
        console.error('TimingRecord Error', e);
        return null;
    }
}
exports.default = record;
const counter = new Map();
function recordMultiple(event, options) {
    try {
        if (!counter.has(event)) {
            counter.set(event, 1);
            return record(event + '-1', options);
        }
        const timesCalled = counter.get(event);
        // typescript complaining about this somehow happening
        if (timesCalled === undefined) {
            return 0;
        }
        const newTimesCalled = timesCalled + 1;
        counter.set(event, newTimesCalled);
        return record(event + '-' + newTimesCalled.toString(), options);
    }
    catch (e) {
        console.error('TimingMultiple Error', e);
    }
}
exports.recordMultiple = recordMultiple;
function difference(eventOne, eventTwo, options) {
    try {
        const delta = getTimeOf(eventTwo) - getTimeOf(eventOne);
        (0, trackTiming_1.trackDelta)(eventOne, eventTwo, delta, options);
        return delta;
    }
    catch (e) {
        console.error('Timing Error', e);
    }
}
exports.difference = difference;
function differenceFromRoot(eventName) {
    try {
        return getTimeOf(eventName) - (0, getInitTime_1.default)();
    }
    catch (e) {
        console.error('Timing error', e);
    }
}
exports.differenceFromRoot = differenceFromRoot;
function recorderFactory(baseOptions) {
    return {
        record: (event, options) => record(event, { ...baseOptions, ...options }),
        recordOnce: (event, options) => recordOnce(event, { ...baseOptions, ...options }),
        recordMultiple: (event, options) => recordMultiple(event, { ...baseOptions, ...options }),
        difference: (eventOne, eventTwo, options) => difference(eventOne, eventTwo, { ...baseOptions, ...options }),
    };
}
exports.recorderFactory = recorderFactory;
/**
 * Used to standardize metrics used within the space of a single application
 *
 * @param appName Expected by DW tracking table
 * @param version Expected by DW tracking table
 * @param baseOptions
 */
function appRecorderFactory(appName, version, baseOptions) {
    baseOptions.additionProps = baseOptions.additionProps ?? {};
    baseOptions.additionProps.appname = appName;
    baseOptions.additionProps.pgk_version = version;
    return recorderFactory(baseOptions);
}
exports.appRecorderFactory = appRecorderFactory;
